import { isPending } from 'app/api/redux-util/async-helpers';
import { createSelector } from 'reselect';
import { getPageBreaks } from 'app/api/redux-jigsaw/jigsaw-selectors';
import { findIndexMatchingCfiFallBackToBefore } from 'app/api/jigsaw-helpers';

const emptyArray = [];

function getRawHighlights(state) {
  const data = state.jigsaw.highlights.data;
  return data ? data.highlights : emptyArray;
}

export const getHighlights = createSelector(
  state => getRawHighlights(state),
  state => getPageBreaks(state),
  (highlights, pageBreaks) => {
    return highlights.map(h => {
      if (!h.startLabel && h.cfi) {
        const index = findIndexMatchingCfiFallBackToBefore(
          pageBreaks,
          el => el.cfi,
          h.cfi
        );
        if (index >= 0) {
          return {
            ...h,
            startLabel: pageBreaks[index].label,
          };
        }
      }
      return h;
    });
  }
);

export function areHighlightsLoading(state) {
  return isPending(state.jigsaw.highlights);
}

export function hasHighlightLoadError(state) {
  return state.jigsaw.highlights.hasError;
}

export function getMarkers(state) {
  const data = state.jigsaw.highlights.data;
  return data ? data.markers : emptyArray;
}

export const getUnsharedMarkers = createSelector(
  state => getMarkers(state),
  markers => markers.filter(m => !m.shared)
);

export function hasHighlights(state) {
  return getHighlights(state).length > 0;
}
